import _ from 'lodash'

import React from 'react'
import './styles.css'
import CommitmentItem from '../Commitments/CommitmentItem'
import { Divider } from '@wework/dieter-ui'

export default function Commitment({
  border,
  floorMap,
  commitmentsFetchDelay,
  divider,
  space,
  borderBottom = false,
}: any) {
  if (!space) {
    return null
  }

  const { reservable } = space
  if (!reservable) {
    return null
  }

  const renderReservationRows = () => {
    const reservations = _.get(space, 'reservable.reservations')

    if (!reservations || _.size(reservations) === 0) {
      return null
    }
    let reservation = _.orderBy(reservations, ['startedOn'], ['asc'])
    return (
      <>
        <div
          style={{
            marginTop: 8,
            position: 'relative',
            padding: '16px 0 16px 16px',
            borderRadius: '.25rem',
            border: border ? '1px solid #E6E6E6' : 0,
            width: '100%',
          }}
        >
          <CommitmentItem
            //@ts-ignore
            reservation={reservation[0]}
            commitmentsFetchDelay={commitmentsFetchDelay}
            key={reservation[0].uuid}
          />
        </div>
        {borderBottom ? <Divider light /> : null}
      </>
    )
  }
  return <>{renderReservationRows()}</>
}
